import initialState from '../store/initial-state'

import {COUNTRY_GET} from "../constants/country-codes";

export default (state = initialState.countryCodes, action) => {
  switch (action.type) {

    case COUNTRY_GET:
      return {
        ...state,
        ...action.payload,
      }
    default: return { ...state }
  }
}